/* import __COLOCATED_TEMPLATE__ from './save-modal-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();